import { Table, TableProps, ColumnsType } from './table'
import { Column, ColumnProps } from './column'

export { Table, Column }
export type { TableProps, ColumnsType, ColumnProps }
